import React from 'react';
import PropTypes from 'prop-types';

const selectorStyles = `
.nzworks-select-wrapper {
  display: inline-block;
  position: relative;
}
.nzworks-select {
  font-size: 1.6rem;
  padding: 0.5em 2.5em 0.5em 0.75em;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  background: #fff url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' stroke='%23444' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 0.75em center/1em;
  appearance: none;
  outline: none;
  transition: border-color 0.2s;
}
.nzworks-select:focus {
  border-color: #485fc7;
}
`;

const Selector = ({ dataList, emptyString = "", name, value, onChange }) => {
    return (
        <>
            <style>{selectorStyles}</style>
            <div className="nzworks-select-wrapper">
                <select
                    className="nzworks-select"
                    name={name}
                    value={value}
                    onChange={onChange}
                >
                    <option value="">{emptyString}</option>
                    {
                        dataList.map(data => (
                            <option key={data} value={data}>{data}</option>
                        ))
                    }
                </select>
            </div>
        </>
    )
}

Selector.propTypes = {
    dataList: PropTypes.array,
    emptyString: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func
}

export default Selector
